module.exports = __webpack_public_path__ + "static/media/glasses.d8eeb412.svg";